var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputTableContainer',{attrs:{"loading":_vm.$apollo.loading,"headers":_vm.headers,"data":_vm.data,"actions":_vm.actions,"sortBy":_vm.sortBy,"sortDesc":_vm.sortDesc,"type":"crew"},scopedSlots:_vm._u([{key:"toolbar-right",fn:function(){return [_c('CrewCreateDropdown')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }